import React from "react";
import { RegisterUserService } from "../../services/registration.service";
import { LoginService } from "../../services/login.service";
import { Pie, Doughnut, Bar, Line } from "react-chartjs-2";
import { Carousel } from "react-responsive-carousel";
// import progressoverview from "../../assets/images/progress-overview.jpg";

class MyAdminCarousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      testData: {},
      displayTitle: "true",
      displayLegend: true,
      legendPosition: "right",
      courseData: {}
    };
  }
  componentDidMount() {
    this.setState({
      testData: {
        labels: ["Initiated", "InProgress", "Completed"],
        datasets: [
          {
            data: [
              //(this.props.learnerProgressOverview || "").testTotal,
              (this.props.learnerProgressOverview || "").testInitiated,
              (this.props.learnerProgressOverview || "").testInProgress || "",
              (this.props.learnerProgressOverview || "").testCompleted || ""
            ],
            backgroundColor: [
              "rgb(0, 82, 143)",
              "rgb(235, 140, 46)",
              "rgb(105, 161, 63)"
            ]
          }
        ]
      },
      courseData: {
        labels: ["Initiated", "InProgress", "Completed"],
        datasets: [
          {
            data: [
              //(this.props.learnerProgressOverview || "").courseTotal,
              (this.props.learnerProgressOverview || "").courseInitiated,
              (this.props.learnerProgressOverview || "").courseInProgress || "",
              (this.props.learnerProgressOverview || "").courseCompleted || ""
            ],
            backgroundColor: [
              "rgb(0, 82, 143)",
              "rgb(235, 140, 46)",
              "rgb(105, 161, 63)"
            ]
          }
        ]
      }
    });
  }
  render() {
    return (
      <Carousel showThumbs={false}>
        <div>
          <h3 className="learner-title">Test Overview</h3>
          <h5 className="progress-title">
            Total Test = {(this.props.learnerProgressOverview || "").testTotal}
          </h5>
          <Pie
            data={this.state.testData}
            width={75}
            height={60}
            options={{
              // title: {
              //   display: this.state.displayTitle
              // },
              legend: {
                display: this.state.displayLegend,
                position: this.state.legendPosition
              }
            }}
          />
        </div>
        <div>
          <h3 className="learner-title">Course Overview</h3>
          <h5 className="progress-title">
            Total Course ={" "}
            {(this.props.learnerProgressOverview || "").courseTotal}
          </h5>
          <Pie
            data={this.state.courseData}
            width={75}
            height={60}
            options={{
              // title: {
              //   display: this.state.displayTitle
              // },
              legend: {
                display: this.state.displayLegend,
                position: this.state.legendPosition
              }
            }}
          />
        </div>
      </Carousel>
    );
  }
}

export default MyAdminCarousel;
